import store from '../store';

export const getUserId = () => store?.getState()?.auth?.user?._id;
